var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',[(_vm.current_user.is_admin)?_c('AdminUser',{attrs:{"user_id":_vm.user_id,"current_user":_vm.current_user}}):_c('PermissionDenied')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }